export const cartConstants = {
    ADD_CART: "ADD_CART",
    GET_CART: "GET_CART",
    REMOVE_CART: "REMOVE_CART"
};
